import React, { Component } from "react";
import edit from "../images/editblack.svg";
import { Form } from "react-bootstrap";
import CustomButton from "./CustomButton";
import Tick from "../images/tick.svg";
import Cancel from "../images/cancel.svg";
import Delete from "../images/deletewhite.svg";
import copy from "../images/copy.svg";
import disable from "../images/disable.svg";
import enable from "../images/enable.svg";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { word } from "../words.js";
import warning from "../images/warning.png";
import Tooltip from "@mui/material/Tooltip";
import { BaseUrl, Authorization, LogoutFunction } from "../static.js";

export default class Category extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showEditBox: false,
      editMode: false,
      categoryValue: "",
      ModalShow: false,
      currentDeleteItemID: "",
      currentDeleteItemName: "",
      deleteLoading: false,
      title: "",
      name: "",
    };

    this.textHandleChange = this.textHandleChange.bind(this);
    this.doneClick = this.doneClick.bind(this);
    this.updateTitle = this.updateTitle.bind(this);

    this.inputName = React.createRef();
    this.categoryObject = React.createRef();
  }

  componentDidMount() {
    this.updateTitle();
  }

  updateTitle() {
    let title = "";
    let name = "";
    this.props.nameObj.forEach((element) => {
      if (
        element.languageId === this.props.selectedLangId &&
        (element.name !== "" ||
          element.name !== null ||
          element.name !== undefined)
      ) {
        title = element.name;
        name = element.name;
      }
    });

    if (title === "") {
      this.props.nameObj.forEach((element) => {
        if (
          element.languageId === this.props.defaultLangId &&
          (element.name !== "" ||
            element.name !== null ||
            element.name !== undefined)
        ) {
          title = element.name;
        }
      });
    }

    if (title === "") {
      this.props.nameObj.forEach((element) => {
        if (
          (element.name !== "" ||
            element.name !== null ||
            element.name !== undefined) &&
          title === ""
        ) {
          title = element.name;
        }
      });
    }

    this.setState({ title: title, name: name }, () => {
      // ReactTooltip.rebuild();
    });
  }

  componentDidUpdate(prvProps) {
    if (
      prvProps.ResetEditMode !== this.props.ResetEditMode &&
      this.props.ResetEditMode === true
    ) {
      this.setState({ editMode: false });
    }

    if (
      this.props.currenCategoryEditMode !== prvProps.currenCategoryEditMode &&
      this.props.currenCategoryEditMode !== this.props.id
    ) {
      this.setState({ editMode: false });
    }

    if (
      prvProps.selectedLangId !== this.props.selectedLangId ||
      prvProps.nameObj !== this.props.nameObj
    ) {
      this.updateTitle();
    }
  }

  // handleClick(){
  //     this.props.categoryClick(this.props.index,this.props.title)
  // }

  onMouseOver() {
    this.setState({ showEditBox: true });
  }

  onMouseOut() {
    this.setState({ showEditBox: false });
  }

  onClick() {
    this.setState(
      { editMode: true, showEditBox: false, categoryValue: this.state.name },
      () => {
        this.inputName.current.focus();
      }
    );
    this.props.enterEditMode(this.props.id);
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  doneClick() {
    this.props.updateCategory(
      this.props.id,
      this.state.categoryValue,
      this.props.isEnable,
      this.props.priority
    );
    this.setState({ editMode: false });
  }

  cancelClick() {
    this.setState({ editMode: false });
  }

  deleteClick() {
    this.setState({ ModalShow: true });
  }

  duplicateClick() {
    let data = {
      languageId: this.props.selectedLangId,
      businessId: Number(this.props.businessId),
      businessCode: this.props.businessCode,
      id: Number(this.props.id),
      name: this.state.name,
      startTime: null,
      endTime: null,
      isEnable: this.props.isEnable,
      priority: this.props.priority,
    };

    data = Object.assign(data, Authorization());

    console.log(data);

    this.setState({ duplicateLoading: true });

    fetch(BaseUrl + "copyCategory", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.setState({ duplicateLoading: false }, () => {
            this.setState({ editMode: false });
          });
          this.props.onDuplicateCategory(result.result);
        } else {
          toast.error("کپی کردن با مشکل مواجه شد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
          this.setState({ duplicateLoading: false });
        }
      })
      .catch((err) => {
        this.setState({ duplicateLoading: false });
        console.log(err);
      });
  }

  disableEnableClick() {
    let enable = this.props.isEnable;
    if (enable === 1) enable = 0;
    else enable = 1;
    this.props.updateCategory(
      this.props.id,
      this.state.name,
      enable,
      this.props.priority
    );
    this.setState({ editMode: false });
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  itemDeleteConfirm() {
    let data = {
      languageId: this.props.selectedLangId,
      businessId: Number(this.props.businessId),
      businessCode: this.props.businessCode,
      categoryId: Number(this.props.id),
      priority: this.props.priority,
    };

    data = Object.assign(data, Authorization());

    this.setState({ deleteLoading: true });

    fetch(BaseUrl + "deleteCategory", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          console.log(result);
          this.setState({ editMode: false }, () => {
            this.props.onDeleteCategory(result.result);
          });
        } else {
          toast.error("حذف با مشکل مواجه شد", {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
        this.setState({ deleteLoading: false }, () => {
          this.hideModal();
        });
      })
      .catch((err) => {
        this.setState({ deleteLoading: false });
        console.log(err);
      });
  }

  handleKeyPress(target) {
    if (target.charCode === 13) {
      this.doneClick();
    }
  }

  render() {
    if (!this.state.editMode) {
      return (
        // onMouseOver={this.onMouseOver.bind(this)} onMouseOut={this.onMouseOut.bind(this)} onClick={this.onClick.bind(this)}
        // <div onClick={this.handleClick.bind(this)} className={this.props.isActive ? 'menu-link menu-link-active' : 'menu-link'}> {this.props.title}</div>
        <div
          className="categoryItemContainer"
          ref={this.props.domRef}
          {...this.props.provided.draggableProps}
          {...this.props.provided.dragHandleProps}
          onMouseOver={this.onMouseOver.bind(this)}
          onMouseOut={this.onMouseOut.bind(this)}
          onClick={this.onClick.bind(this)}
        >
          <div
            className="menu-link"
            style={{
              color:
                this.props.isEnable === 1 && this.state.name === ""
                  ? "var(--gray3)"
                  : this.props.isEnable === 1 && this.state.name !== ""
                  ? "#7d7d7d"
                  : "var(--gray2)",
            }}
          >
            {this.state.title}
            {(this.state.name === "" || this.props.OPWarning) && (
              <Tooltip
                content={
                  !this.state.name
                    ? "عنوان دسته را در زبان مورد نظر تکمیل کنید"
                    : this.props.OPWarning
                    ? "این دسته در هیچ یک از گام‌های روال سفارش به کار نرفته است"
                    : ""
                }
              >
                <img
                  src={warning}
                  alt=""
                  style={{
                    margin:
                      this.props.rtlClass === "ltrStyle"
                        ? "0px 0px 0px 0px"
                        : "0px 10px 0px 0px",
                    width: "16px",
                    height: "16px",
                    objectFit: "contain",
                  }}
                  // data-tip={
                  //   !this.state.name
                  //     ? "عنوان دسته را در زبان مورد نظر تکمیل کنید"
                  //     : this.props.OPWarning
                  //     ? "این دسته در هیچ یک از گام‌های روال سفارش به کار نرفته است"
                  //     : ""
                  // }
                  // data-delay-show="300"
                  // data-delay-hide="200"
                />
              </Tooltip>
            )}
          </div>

          <div
            className="categoryItemEditBox"
            style={{
              visibility: this.state.showEditBox ? "visible" : "hidden",
            }}
          >
            <img
              src={edit}
              alt=""
              style={{ height: "100%", width: "100%", objectFit: "contain" }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div
          className="categoryItemContainer"
          style={{ marginLeft: "10px" }}
          ref={this.props.domRef}
          {...this.props.provided.draggableProps}
          {...this.props.provided.dragHandleProps}
        >
          <div style={{ width: "30px", marginRight: "5px" }}>
            <CustomButton
              title=""
              img={Delete}
              backColor="var(--brown2)"
              onClick={this.deleteClick.bind(this)}
            />
          </div>
          <div style={{ width: "30px", marginRight: "5px" }}>
            <CustomButton
              title=""
              img={copy}
              backColor="var(--brown2)"
              onClick={this.duplicateClick.bind(this)}
            />
          </div>
          <div style={{ width: "30px", margin: "0px 5px" }}>
            <CustomButton
              title=""
              img={this.props.isEnable !== 0 ? disable : enable}
              backColor="var(--brown2)"
              onClick={this.disableEnableClick.bind(this)}
            />
          </div>
          <Form.Control
            className={"inputStyleForm" + this.props.rtlClass}
            style={{ maxWidth: "150px", minWidth: "120px" }}
            placeholder={word[this.props.currentLang]["categoryName"]}
            type="text"
            name="categoryValue"
            onChange={this.textHandleChange}
            value={this.state.categoryValue}
            disabled={this.state.buttonDisabled}
            ref={this.inputName}
            onKeyPress={this.handleKeyPress.bind(this)}
          />
          <div style={{ width: "30px", marginRight: "5px" }}>
            <CustomButton
              title=""
              img={Tick}
              backColor="var(--brown2)"
              onClick={this.doneClick}
            />
          </div>
          <div style={{ width: "30px", marginRight: "5px" }}>
            <CustomButton
              title=""
              img={Cancel}
              backColor="var(--black1)"
              onClick={this.cancelClick.bind(this)}
            />
          </div>

          <Modal
            show={this.state.ModalShow}
            animation={false}
            onHide={this.hideModal.bind(this)}
            centered
          >
            <div className="dialogBox">
              اطمینان از حذف "{this.state.title}"؟
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="خیر"
                    imgHeight={19}
                    backColor="var(--black1)"
                    imgWidth={25}
                    minHeight="35px"
                    img={Cancel}
                    onClick={this.hideModal.bind(this)}
                  />
                </div>
                <div style={{ minWidth: "5px" }} />
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="بله"
                    loading={this.state.deleteLoading}
                    imgHeight={20}
                    imgWidth={25}
                    minHeight="35px"
                    img={Tick}
                    onClick={this.itemDeleteConfirm.bind(this)}
                  />
                </div>
              </div>
            </div>
          </Modal>
        </div>
      );
    }
  }
}
